/** @jsx jsx */
import { jsx, Box, Text, IconButton, Flex, Heading } from 'theme-ui'
import { useModal } from 'react-modal-hook'
import AfterPayLogo from '../../icons/AfterPayLogo.svg'
import Modal from '../shared/Modal/Modal'
import Body from '../shared/Typography/Body/Body'
import styled from '@emotion/styled'
import formatPrice from '../../utils/formatPrice'
import info2 from '../../icons/info2.svg'
import AfterPay1 from '../../icons/AfterPay1.svg'
import AfterPay2 from '../../icons/AfterPay2.svg'
import AfterPay3 from '../../icons/AfterPay3.svg'
import AfterPay4 from '../../icons/AfterPay4.svg'
import AfterPayLogoTransparent from '../../icons/AfterPayLogoTransparent.svg'
const LogoWrapper = styled(Flex)`
  flex: 1;
  flex-direction: ${props => (props.mobile ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`

const Logo = styled.img`
  width: ${props => (props.mobile ? '50px' : '50%')};
  ${'' /* height: ${props => (props.mobile ? '30%' : '50%')}; */}
  margin-bottom: ${props => !props.mobile && '50px'};
`

const LogoDescription = styled(Text)`
  margin-top: (props.mobile ? '0' : '30px')};
  line-height: 16px;
  width: 90%;
  text-align: ${props => (props.mobile ? 'left' : 'center')};
  margin-left: ${props => props.mobile && '25px'};

`

const AfterPay = ({ currentValue, mobile }) => {
  const [showModal, hideModal] = useModal(
    () => (
      <Modal
        flush={true}
        isOpen
        onRequestClose={hideModal}
        hideModal={hideModal}
        style={{
          // overlay: { width: '100vw', height: '100vh' },
          content: {
            width: '80vw',
            height: 'auto',
            maxHeight: '90%',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'block',
            margin: 'auto',
            bottom: 'auto',
          },
        }}
      >
        <Flex
          sx={{
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <img
            src={AfterPayLogoTransparent}
            sx={{
              width: mobile ? '50%' : '30%',
              height: 'auto',
              display: 'block',
              margin: 'auto',
              py: mobile ? '20px' : '40px',
            }}
          />
          <Heading
            as="h5"
            sx={{
              textAlign: 'center',
              mb: mobile ? '20px' : '50px',
              fontFamily: 'Avenir',
            }}
          >
            Shop Now. Enjoy Now. Pay Later.
          </Heading>
          <Flex
            sx={{
              margin: mobile ? '0px' : '30px 20px',
              flexDirection: mobile ? 'column' : 'row',
              justifyContent: mobile ? 'flex-start' : 'space-evenly',
              alignItems: 'flex-start',
            }}
          >
            <LogoWrapper mobile={mobile}>
              <Logo src={AfterPay1} mobile={mobile} />
              <LogoDescription variant="caption" mobile={mobile}>
                Add favorites to cart
              </LogoDescription>
            </LogoWrapper>
            <LogoWrapper mobile={mobile}>
              <Logo src={AfterPay2} mobile={mobile} />
              <LogoDescription variant="caption" mobile={mobile}>
                Select Afterpay at checkout
              </LogoDescription>
            </LogoWrapper>
            <LogoWrapper mobile={mobile}>
              <Logo src={AfterPay3} mobile={mobile} />
              <LogoDescription
                variant="caption"
                mobile={mobile}
                sx={{ lineHeight: '20px' }}
              >
                Log into or create your Afterpay account, with instant approval
                decision
              </LogoDescription>
            </LogoWrapper>
            <LogoWrapper mobile={mobile}>
              <Logo src={AfterPay4} mobile={mobile} />
              <LogoDescription
                variant="caption"
                mobile={mobile}
                sx={{ lineHeight: '20px' }}
              >
                Your purchase will be split into 4 payments, payable every 2
                weeks
              </LogoDescription>
            </LogoWrapper>
          </Flex>
          <Body
            variant="caption"
            sx={{
              mb: '30px',
              textAlign: 'center',
              color: 'lightGray',
              lineHeight: '18px',
              fontSize: mobile && '10px',
              bottom: 0,
              left: 0,
              px: '30px',
            }}
          >
            You must be over 18, a resident of the U.S. and meet additional
            eligibility criteria to qualify. Late fees may apply. Estimated
            payment amounts shown on product pages exclude taxes and shipping
            charges, which are added at checkout. Check the Installment
            Agreement link below for complete terms. Loans to California
            residents made or arranged pursuant to a California Finance Lenders
            Law license. © 2020 Afterpay
          </Body>
        </Flex>
      </Modal>
    ),
    [mobile]
  )

  const AfterPayWrap = styled(Flex)`
    flex-direction: row;
    align-items: center;
  `

  return (
    <Box sx={{ mt: '5px', mb: '5px' }}>
      <AfterPayWrap>
        <Body variant="caption" sx={{ letterSpacing: '0px' }}>
          or 4 interest-free installments of{' '}
          <Text as="span" variant="bold">
            {currentValue && formatPrice(currentValue.price / 4)}{' '}
          </Text>
          by
        </Body>
        <IconButton
          sx={{
            width: 80,
            p: '0px',
          }}
        >
          <img style={{ width: '100%' }} src={AfterPayLogo} alt="afterPay" />
        </IconButton>
        <IconButton onClick={showModal} sx={{ marginLeft: '-10px' }}>
          <img style={{ width: '60%' }} src={info2} alt="info" />
        </IconButton>
      </AfterPayWrap>
    </Box>
  )
}

export default AfterPay
